<template>
  <PainelLayout>
    <Breadcrumb :lista="[{ 'name':'Painel', 'link' : '/' }]" />

    <div class="row">
      <div class="col-6">
        <h1>Locações</h1>
      </div>
      <div class="col-6 text-end">
        <router-link v-if="!isOpeto" to="/rental/new">
          <button class="btn btn-primary mt-3">Nova Locação</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <RentalFilters
      :filters="filters"
      :available-statuses="availableStatuses"
      @reset="resetFilters"
    />

    <div v-if="!loading">
      <div v-if="filteredList.length != 0" class="row">
        <RentalCard v-for="loc in filteredList" :key="loc.id"
          :status="loc.status"
          :rental-id="'code'"
          :client-name="loc.client.name"
          :value="loc.final_amount"
          :show-value="isOpeto ? false : true"
          :start-date="loc.dateStart"
          :end-date="loc.date_end"
          :location="loc.city"
          :delivery-type="loc.withdrawal ? 'pickup' : 'delivery'"
          :next-action-date="nextActionDate(loc)"
          :to="`/rental/details?id=${loc.id}`"
        />
      </div>
      <div v-else class="text-center text-muted p-4">
        Nenhuma locação encontrada para os filtros selecionados.
      </div>
      <div style="height: 15px;"></div>
    </div>
    <div v-else class="d-flex justify-content-center p-3 mb-4">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div style="height: 10px;"></div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { rental } from '@/models/rental';
import { onMounted, ref, reactive } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import statusFormat from '@/services/statusFormat.js';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import RentalCard from '@/components/RentalCard.vue';
import RentalFilters from '@/components/RentalFilters.vue';
import { useRentalFilters } from '@/composables/useRentalFilters';

export default {
  name: "RentalView",
  components: { PainelLayout, Breadcrumb, RentalCard, RentalFilters },
  setup(props) {
    const toastStore = useToastStore();
    const lista = ref([]);
    const loading = ref(true);
    const model = rental();

    const itemobj = reactive({
      id: null,
      client: null,
      city: ''
    });

    const { isAdmin, isUser, isOpeto } = usePermissions();
    const { filters, filteredList, availableStatuses, resetFilters, nextActionDate } = useRentalFilters(lista);

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list();
      } catch (e) {
        toastStore.show(parseError(e));
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      list();
    });

    return {
      list,
      lista,
      loading,
      itemobj,
      statusFormat,
      isAdmin,
      isUser,
      isOpeto,
      filters,
      filteredList,
      availableStatuses,
      resetFilters,
      nextActionDate,
    }
  }
}
</script>